import { render, staticRenderFns } from "./VuePlotly.vue?vue&type=template&id=01d01778&"
import script from "./VuePlotly.vue?vue&type=script&lang=js&"
export * from "./VuePlotly.vue?vue&type=script&lang=js&"
import style0 from "./VuePlotly.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports